// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","vGray14":"#7d85a4","event":"CalendarMonthEvent_event__ADAsL","time":"CalendarMonthEvent_time__2hxq_","title":"CalendarMonthEvent_title__3A4i9"};